export default __webpack_public_path__ + "static/media/Books.3783698b.svg";